<template>
  <div class="page-container categories-list">
    <div class="page-title-container">
      <h1 class="page-title">Páginas</h1>
    </div>

    <div class="table-container">
      <div class="table-header">
        <div
          class="d-flex flex-column flex-md-row justify-content-between align-items-start position-relative"
        >
          <div class="w-full w-md-auto md-flex-1">
            <div
              class="d-flex justify-content-end align-items-center justify-content-lg-start"
            >
              <div class="d-flex d-md-none">
                <button
                  type="button"
                  class="button-tooltip text-dark font-weight-bold"
                  v-b-tooltip.hover
                  title="Recargar"
                  @click="loadData()"
                >
                  <i class="ri-loop-right-line"></i>
                </button>
              </div>
            </div>
          </div>

          <section
            class="w-full w-md-auto md-flex-1 d-flex justify-content-end align-items-center mt-2 mt-md-0"
          >
            <div class="d-none d-md-flex">
              <button
                type="button"
                class="button-tooltip text-dark font-weight-bold"
                v-b-tooltip.hover
                title="Recargar"
                @click="loadData()"
              >
                <i class="ri-loop-right-line"></i>
              </button>
            </div>

            <div class="w-full w-md-auto d-flex flex-column flex-md-row">
              <SearchBar
                placeholder="Buscar por usuario, nombres y apellidos o celular"
                @search="onSearch"
                @input="search = $event"
                class="flex-1"
              />
            </div>
          </section>
        </div>
      </div>

      <div>
        <!-- Mobile -->
        <div class="custom-table-mobile d-xl-none">
          <section class="custom-table-mobile-header">
            <div>
              <span>Nombre</span>
            </div>
            <div>
              <span>Enlace</span>
            </div>
          </section>

          <div class="custom-table-mobile-body">
            <div class="custom-table-mobile-row" v-for="o in list" :key="o.id">
              <div class="custom-table-mobile-grid">
                <div>
                  <span>{{ o.name }}</span>
                </div>

                <div>
                  <a :href="setUrl(o)" target="_blank">
                    <i class="ri-external-link-line"></i>
                  </a>
                </div>

                <div>
                  <button
                    type="button"
                    class="border-0 bg-transparent"
                    @click="o.showMobileData = !o.showMobileData"
                  >
                    <span v-if="!o.showMobileData">
                      <i class="ri-arrow-down-s-line"></i>
                    </span>
                    <span v-else>
                      <i class="ri-arrow-up-s-line"></i>
                    </span>
                  </button>
                </div>
              </div>

              <div class="custom-table-mobile-options mt-3">
                <router-link
                  :to="{ name: 'config-pages-edit', params: { id: o.id } }"
                >
                  Editar
                </router-link>
              </div>

              <div class="pt-3" v-if="o.showMobileData">
                <ul class="list-unstyled p-0">
                  <li class="mb-1">
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Título SEO:</span
                    >
                    <span class="d-inline-block ml-1">
                      {{ o.seoTitle || "-" }}</span
                    >
                  </li>
                  <li class="mb-1">
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Última actualización:</span
                    >
                    <span class="d-inline-block ml-1">
                      {{ o.updatedAt || "-" }}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Desktop -->
        <table class="custom-table w-100 d-none d-xl-table">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Enlace</th>
              <th>Título SEO</th>
              <th>Última actualización</th>
              <th class="pr-md-4">Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="o in list" :key="o.id">
              <td class="pl-md-4">
                {{ o.name }}
              </td>
              <td class="text-center">
                <a :href="setUrl(o)" target="_blank">
                  <i class="ri-external-link-line"></i>
                </a>
              </td>
              <td class="pl-md-4">
                {{ o.seoTitle || "-" }}
              </td>
              <td class="text-center">
                {{ o.updatedAt || "-" }}
              </td>
              <td class="text-center d_option pr-md-4">
                <DropdownTable>
                  <template slot="dropdown-content">
                    <DropdownItem
                      :to="{ name: 'config-pages-edit', params: { id: o.id } }"
                      text="Editar"
                    />
                  </template>
                </DropdownTable>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        class="table-footer d-flex justify-content-end align-items-center"
        v-if="list.length"
      >
        <pagination
          :total="total"
          :page="page"
          :page-size="pageSize"
          :pages="pages"
          :changePage="changePage"
          :changePageSize="changePageSize"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  Alert,
  PaginationMixin,
  DropdownTable,
  DropdownItem,
  SearchBar
} from "@wizepe/wize-admin";

import { PostService } from "@/core/services";

export default {
  components: {
    SearchBar,
    DropdownTable,
    DropdownItem
  },
  mixins: [PaginationMixin],
  data() {
    return {
      list: [],
    };
  },
  methods: {
    async loadData() {
      try {
        await this.$store.dispatch("app/loading", true);
        const params = {
          page: this.page - 1,
          size: this.pageSize,
          sort: "id,asc",
          search: this.search,
        };
        const response = await PostService.list(params);

        this.list = response.payload.content.map((item) => {
          return {
            ...item,
            showMobileData: false,
          };
        });

        this.total = response.payload.totalElements;
        this.pages = response.payload.totalPages;
      } catch (error) {
        console.error(error);
        Alert.error(error);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    setUrl(item) {
      return `${process.env.VUE_APP_WEB_URL}/${item.slug}`;
    },
  },
  async mounted() {
    await this.loadData();
  },
};
</script>

<style lang="stylus" scoped></style>
